import { render, staticRenderFns } from "./AppBarRoutesMenu.vue?vue&type=template&id=46207de6&scoped=true&"
import script from "./AppBarRoutesMenu.vue?vue&type=script&lang=js&"
export * from "./AppBarRoutesMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppBarRoutesMenu.vue?vue&type=style&index=0&id=46207de6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46207de6",
  null
  
)

export default component.exports